import React, { useEffect, useState } from "react";
import { IoArrowForward } from "react-icons/io5";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";
import * as s from "./index.module.scss";
import Popups from "../Popups";

const HeroContent = ({
  caption,
  title,
  description,
  features,
  sideImage,
  sideImageMobile,
  viewMoreLink,
  homepage = false,
  visibility,
  page = "",
  normalHeading = true,
}) => {
  const [showModal, setShowModal] = useState(false);
  // const isButtonVisible = visibility !== "hidden";

  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    // Set initial window width
    handleResize();
    // Attach event listener for window resize
    window.addEventListener("resize", handleResize);
    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Container>
      <Row className="flex-md-row-reverse align-items-center">
        <Col xs={12} md={6}>
          {sideImageMobile && windowWidth < 768 ? (
            <img src={sideImageMobile} alt="image" height="100%" priority />
          ) : sideImage && windowWidth >= 768 ? (
            <img
              src={sideImage}
              alt="image"
              height="100%"
              fetchPriority="high"
            />
          ) : (
            <div style={{ height: windowWidth < 768 ? "73vw" : "600px" }}></div>
          )}
        </Col>
        <Col xs={12} md={6} className={`mt-4 mt-md-0 ${s.cel_content}`}>
          {caption && <h5 className={s.caption}>{caption}</h5>}

          {homepage && (
            <div className={`${s.title}`}>
              {Array.isArray(title) ? <PrismicRichText field={title} /> : title}
            </div>
          )}

          {normalHeading && <h1 className={`${s.title}`}>{title}</h1>}

          {description && (
            <div className={`paragraph fw-normal ${secondaryFont}`}>
              {homepage && <PrismicRichText field={description} />}
              {!homepage && <PrismicRichText field={description} />}
            </div>
          )}
          <div className={`${s.points}`}>
            {features?.map((item, idx) => {
              return (
                <div key={idx} className={`${secondaryFont} ${s.single_point}`}>
                  {item.icon.url && (
                    <img
                      src={item.icon.url}
                      alt={item.icon.url || "icon"}
                      height="100%"
                    />
                  )}
                  <div className="fw-normal caption">{item.feature}</div>
                </div>
              );
            })}
          </div>
          <div className={s.button_container}>
            <button
              className={`btn btn-mob-full-w btn-primary mb-lg-0 me-md-4 d-md-inline ${secondaryFont}`}
              onClick={() => {
                setShowModal(true);
              }}
            >
              Get an offer now <IoArrowForward size="18px" />
            </button>
            {visibility && (
              <Link
                href={viewMoreLink}
                className={`btn btn-mob-full-w btn-outline-dark ${secondaryFont}`}
              >
                View More <IoArrowForward size="18px" />
              </Link>
            )}
          </div>
        </Col>
      </Row>
      <Popups
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        page={page}
      />
    </Container>
  );
};

export default HeroContent;
